module.exports = __webpack_public_path__ + "img/mo5.b57493af.png";